import { CommonModule } from '@angular/common';
import { Component, ENVIRONMENT_INITIALIZER, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FichaRegistro } from 'app/models/fichaRegistro.model';
import { BuscadorGestionesComponent } from 'app/modules/SharedEntitiesComponents/buscador-gestiones/buscador-gestiones.component';
import { DataTiposGestionesBienesCulturales, ResponseTiposGestionesBienesCulturales } from '../../tabs/documentos-emitidos/models/gestiones-bienes-culturales';
import { DetalleBienCulturalService } from '../../detalle-bien-cultural.service';
import { UtilsService } from 'app/modules/utils-service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DocumentosEmitidosService } from '../../tabs/documentos-emitidos/documentos-emitidos.service';
import { environment as env } from 'environments/environments';
import { Tipologia } from 'app/models/tipologias.model';
import { ActualizarColeccionModel } from '../models/actualizar-coleccion.model';
import { MatSelectModule } from '@angular/material/select';
import { CONSTANTS } from 'app/core/constants';
import { AcutalizarColeccionService } from './actualizar-coleccion.service';

@Component({
    selector: 'actualizar-coleccion',
    templateUrl: 'actualizar-coleccion.component.html',
    imports:[
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        CommonModule,
        MatButtonModule,
        MatCheckboxModule,
        MatSelectModule,

        BuscadorGestionesComponent,
    ]
})

export class ActualizarColeccionComponent implements OnInit {
    listaGestiones: DataTiposGestionesBienesCulturales[] = [];
    gestionesSeleccionadasPadre: DataTiposGestionesBienesCulturales[] = [];

    fichaRegistro:FichaRegistro
    cambioNoRegistro: boolean= false
    seccion:number
    tiposColeccion:number[]= [
        CONSTANTS.TIPOLOGIA_ID_COLECCION_PREHISPANICA, 
        CONSTANTS.TIPOLOGIA_ID_COLECCION_BIENES_INMUEBLES, 
        CONSTANTS.TIPOLOGIA_ID_COLECCION_HISPANICA_REPUBLICANA
    ]
    colecciones:Tipologia[]=[]

    cambioColeccion:ActualizarColeccionModel = new ActualizarColeccionModel
    
    constructor(
        public dialogRef: MatDialogRef<ActualizarColeccionComponent>,
        private documetosEmitidosService: DocumentosEmitidosService,
        private detalleBienesService: DetalleBienCulturalService,  
        private acutalizarColeccionService: AcutalizarColeccionService,
        private utilsService: UtilsService,     
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: FichaRegistro
    ) { 
        this.fichaRegistro= this.data
        this.getTiposGestionesBines()
        this.getColecciones()
    }

    ngOnInit() { }

    getTiposGestionesBines(){
        this.documetosEmitidosService.getGestionesByBienesCulturales()
            .then((response:ResponseTiposGestionesBienesCulturales)=>{
                this.listaGestiones= response.data
            })
    }

    getColecciones(): void {
        let tipologiaIdColeccion: number = 0;
        this.seccion= this.fichaRegistro.seccion.tipologiaId

        if (this.seccion === env.TIPOLOGIA_ID_SECCION_PREHISPANICA) {
            tipologiaIdColeccion = this.tiposColeccion[0]; 
        } else if (this.seccion === env.TIPOLOGIA_ID_SECCION_BIENES_INMUEBLES) {
            tipologiaIdColeccion = this.tiposColeccion[1];
        } else if (this.seccion === env.TIPOLOGIA_ID_SECCION_HISPANICA_REPUBLICANA) {
            tipologiaIdColeccion = this.tiposColeccion[2];
        }

        this.detalleBienesService.getTipologias(tipologiaIdColeccion)
        .then((response: Tipologia[]) => {
            this.colecciones = response;
            // Establecer valor inicial del mat-select
            const valorInicial = this.colecciones.find(
                (c) => c.tipologiaId === this.fichaRegistro.coleccion.tipologiaId
            );

            this.cambioColeccion.nuevaColeccion = valorInicial ?? null;
        })
        .catch(error => {
            console.error('Error al obtener colecciones:', error);
        });
    }

    actualizarColeccion(){
        this.cambioColeccion.bienCulturalUuid=this.fichaRegistro.bienCulturalUuid
        this.cambioColeccion.gestionesUuid = this.gestionesSeleccionadasPadre.map(g => g.gestionUuid)
        this.acutalizarColeccionService.actualizacionColeccion(this.cambioColeccion)
            .then((response:any)=>{
                this.dialogRef.close(false)
                this.detalleBienesService.getFichaRegistro(this.fichaRegistro.bienCulturalUuid),
                this.utilsService.openSuccessSnakBar(response.message)
            })
        
    }

}